import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const ReelPlayerPage = () => {
  const { id } = useParams();
  const [reel, setReel] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReelData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetch(`/api/reels/${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setReel(data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching reel:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReelData();
  }, [id]);

  const getHeaderTitle = () => {
    if (isLoading) return "Loading Reel...";
    if (error || !reel) return "Reel Not Found";
    return reel.title;
  };

  return (
    <div className="reel-player-main">
      {isLoading && <p className="text-center p-4">Loading...</p>}
      {error && <p className="error-message p-4">Error: {error}</p>}
      {!isLoading && !reel && <p className="text-center p-4">Sorry, we couldn't find that reel.</p>}
      {reel && (
        <div className="reel-player-container">
          <video
            src={reel.video_url}
            className="reel-video-element"
            controls
            autoPlay
            playsInline
            loop
          >
            Your browser does not support the video tag.
          </video>
        </div>
      )}
    </div>
  );
};

export default ReelPlayerPage;
